let data = {

  brief: '聚木网隶属于上海聚木共利数字科技有限公司，是专注于木材交易的互联网平台。创始团队由资深木材生产企业高管和产业互联网精英组成，团队拥有多年大宗商品交易经验，凭借深耕在木材工厂和建筑材料市场累计20余年的经验，赋能相关企业.',

  kefuPhone: '180 8672 7328',

  gqTap: [{
    name: '求购',
    val: 0
  }, {
    name: '供应',
    val: 1
  }],

  qgTag: [
    {img:'jx.png',val:'4'},
    {img:'tj.png',val:'5'},
    {img:'rm.png',val:'6'},
    {img:'jq.png',val:'7'},
  ],

  gyTag: [
    {img:'jx.png',val:'1'},
    {img:'tj.png',val:'2'},
    {img:'rm.png',val:'3'},
  ],

  gsnm: '聚木网',
  nav: [{
      name: '首页',
      id: 0,
      path: '/index'
    },
    {
      name: '供求中心',
      id: 1,
      path: '/demand'
    },
    {
      name: '资讯中心',
      id: 2,
      path: '/news'
    },
    {
      name: '行情中心',
      id: 3,
      path: '/market'
    },
    {
      name: '商家入驻',
      id: 4,
      path: '/settled'
    },
    {
      name: '关于我们',
      id: 5,
      path: '/abous'
    }
  ],

  tap: [{
    name: '建筑木方',
    val: '100000'
  }, {
    name: '建筑模板',
    val: '200000'
  }],

  gslist: [{
      id: 0,
      name: '平台使命',
      txt: '帮助用户降本增效，为供应商创建价值。打造木材供需双方共赢的健康生态链',
      img: '/static/imgs/Mission@1x.png'

    },
    {
      id: 1,
      name: '平台愿景',
      txt: '成为最专业的的全球木材资源整合服务商',
      img: '/static/imgs/vision@1x.png'

    },
  ],
  superiority: [{
      id: 0,
      name: '一站式建筑木材供应链',
      txt: '一站式服务，强大的集采优势',
      img: '/static/imgs/Rectangle 1052.png'

    },
    {
      id: 1,
      name: '阳光、透明、高效的可靠交易',
      txt: '可靠的可视化交易，质检保证和全过程可视化，物流可循迹，售后有保障',
      img: '/static/imgs/Rectangle 1054.png'

    },
    {
      id: 2,
      name: '专业的人才团队',
      txt: '深耕建筑木方模板领域，20年工厂及采购经验，全国各地均有网点',
      img: '/static/imgs/Rectangle 1057.png'

    },
    {
      id: 3,
      name: '专业化的质检服务',
      txt: '根据明确的质量标准进行生产，由平台指定的专业质检人员进行质检，提供可视化的检测流程',
      img: '/static/imgs/Rectangle 1058.png'

    }
  ],
  jingyan: [{
      id: 0,
      name: '行业经验',
      txt: '20+',
      tyt: '深耕行业20余年',
      img: '/static/imgs/quest@1x.png'

    },
    {
      id: 1,
      name: '客户数量',
      txt: '5700+',
      tyt: '截止当前，平台拥有客户数量5700+',
      img: '/static/imgs/client@1x.png'
    },
    {
      id: 2,
      name: '订单总量',
      txt: '50k+',
      tyt: '截止当前，平台已产生50000+订单',
      img: '/static/imgs/order@1x.png'


    },
    {
      id: 3,
      name: '全国网点',
      txt: '17',
      tyt: '截止当前，全国共设有17家网点',
      img: '/static/imgs/dot@1x.png'
    }
  ],
  lxfs: [{
      id: 0,
      value: '综合咨询：400-881-3166'
    },
    {
      id: 1,
      value: '占经理：180-8672-7328'
    },
    {
      id: 2,
      value: '祝经理：166-0611-9981'
    }
  ],
  Copyright: 'Copyright @ 2023 JUMUGONGLI All Rights Reserved. | ',
  Copyright2: '沪ICP备2023017093号-1',
  categoryArr: [{
    name: '木方',
    val: 100000
  }, {
    name: '模板',
    val: 200000
  }, {
    name: '古建',
    val: 300000
  }, {
    name: '托盘',
    val: 400000
  }, {
    name: '板材',
    val: 500000
  }, {
    name: '其他',
    val: 900000
  }],
  unitArr: [{
    name: '立方',
    val: 0
  }, {
    name: '根',
    val: 1
  }, {
    name: '张',
    val: 2
  }],
  pages: {
    page: 1,
    limit: 10
  },
  hqdata: [{
      id: 0,
      name: '材质',
      prop: 'categoryName'
    },
    {
      id: 1,
      name: '规格',
      prop: 'materialSpec'
    },
    {
      id: 2,
      name: '通货',
      prop: 'currencyPriceAfterTax'
    },
    {
      id: 3,
      name: '半精品',
      prop: 'halfBoutiquePriceAfterTax'
    },
    {
      id: 4,
      name: '精品',
      prop: 'boutiquePriceAfterTax'
    },
    {
      id: 5,
      name: '四面见线',
      prop: 'allSidesPriceAfterTax'
    }
  ],
  gnarr: [{
      id: 0,
      name: '发布询价',
      img: '/static/imgs/发布 1@2x.png',
      txt: '极速询价：填写大概需求，由客服专员和您对接，及时反馈报价'
    },
    {
      id: 1,
      name: '市场行情',
      img: '/static/imgs/Icon@2x.png',
      txt: '全国各地各品种木材价格参考，方便比价'
    },
    {
      id: 2,
      name: '专业资讯',
      img: '/static/imgs/资讯 1@2x.png',
      txt: '实时推送木材行业相关资讯，方便您及时了解行业信息'
    },
    {
      id: 3,
      name: '每日精选',
      img: '/static/imgs/Icon@2x (1).png',
      txt: '每日推出超高性价比的精选木材'
    },
    {
      id: 4,
      name: '专业质检',
      img: '/static/imgs/质检结果 1@2x.png',
      txt: '专业化的质检服务，可视化的检测流程，对质量控制过程有充分了解'
    },
    {
      id: 5,
      name: '可视交易',
      img: '/static/imgs/Frame 427318677@2x.png',
      txt: '可视化的加工、质检、装车流程和物流信息以及书面化的质量标准'
    }
  ],
  contact: [{
      id: 0,
      name: '小程序',
      cont: '/static/imgs/phone/xcx.jpg',
      ico: '/static/imgs/phone/QQ@1x.png'
    },
    {
      id: 1,
      name: '电话',
      cont: '确认拨打电话:13182605678 吗？',
      ico: '/static/imgs/phone/telephone@1x.png'
    },
    {
      id: 2,
      name: '微信',
      cont: '/static/imgs/phone/weixin.png',
      ico: '/static/imgs/phone/wechat@1x.png'
    }
  ]
}

export default data;



//////////////////
// WEBPACK FOOTER
// ./static/data.js
// module id = I+VY
// module chunks = 1